import Divider from '@/component/Divider'
import Empty from '@/component/Empty'
import Loading from '@/component/Loading'
import TGASDK from '@/config/TGASDK'
import { Wallet } from '@kulee/tga-sdk'
import type { CurrencyCode, TradeRecord } from '@kulee/tga-sdk/types/types/wallet'
import React, { Fragment, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import InfiniteScroll from 'react-infinite-scroll-component'
import TradeRecordItem from '../TradeRecordItem'

const PAGE_SIZE = 20

const TradeRecords: React.FC<PropType> = ({ currency }) => {
  const { t } = useTranslation()
  const [tradeRecord, setTradeRecord] = useState<TradeRecord[]>()
  const [pageNum, setPageNum] = useState<number>(1)
  const [hasMore, setHasMore] = useState(true)

  const fetchData = async () => {
    const { data, total } = await TGASDK.module.Wallet.service.getTradeRecordList({
      pageNum: pageNum,
      pageSize: PAGE_SIZE,
      currencyCode: currency,
      orderByColumn: 'createTime',
      isAsc: 'desc'
    })
    setHasMore(pageNum * PAGE_SIZE < total)
    setPageNum(pageNum + 1)
    setTradeRecord([...(tradeRecord ? tradeRecord : []), ...data])
  }

  useEffect(() => {
    TGASDK.addModule(Wallet)
    fetchData()
  }, [])

  if (!tradeRecord) {
    return <Loading className="h-40" />
  }

  if (tradeRecord.length <= 0) {
    return <Empty className="pt-24" />
  }

  const loader = <div className="text-center">{t('tip.loadMore')}</div>
  const endMessage = <div className="text-center text-fontcolor-300">{t('tip.nothingMore')}</div>
  const eleId = `billingScroll_${currency}`

  return (
    <div id={eleId} className="h-[calc(100vh-9rem)] overflow-auto pr-md lg:h-[calc(100vh-9.2rem)]">
      <InfiniteScroll
        dataLength={tradeRecord.length}
        next={fetchData}
        hasMore={hasMore}
        loader={loader}
        endMessage={endMessage}
        scrollableTarget={eleId}
      >
        {tradeRecord.map((item, index) => (
          <Fragment key={index}>
            <TradeRecordItem item={item} />
            <Divider />
          </Fragment>
        ))}
      </InfiniteScroll>
    </div>
  )
}

interface PropType {
  currency: CurrencyCode
}

export default TradeRecords
